import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ${"" /* background-color: #FAFAFA; */}
  margin: 0 50px 0 50px;
  padding: 18px 0;
  @media (max-width: 1000px) {
    margin: 0 30px;
  }
`;

export const Heading = styled.h1`
  margin: 0;
  font-family: NunitoSans-Bold;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 65.47px;
  letter-spacing: 1.5px;

  /* black */

  color: #000000;
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 33px;
    text-align: left;
  }
`;

export const ImageSwiper = styled.div`
  flex: 1;
  padding: 18px 0;
`;

export const Line = styled.div`
  width: 100px;
  height: 3px;
  background-size: cover;
  background-image: url("/images/icons/Rectangle 36.png");
`;

export const Icon = styled.div`
  width: 20px;
  height: 20px;
  margin-top: 5px;
  margin-right: 10px;
  background-size: cover;
  background-image: url("/images/icons/Vector (9).png");
  @media (max-width: 1024px) {
    width: 25px;
    height: 15px;
  }
  @media (max-width: 600px) {
    width: 25px;
    height: 15px;
  }

  @media (max-width: 950px) {
    width: 28px;
    height: 26px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SubHeading = styled.p`
  margin: 0;
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 10px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #444444;
  @media (max-width: 1024px) {
    text-align: left;
  }
  @media (max-width: 600px) {
    text-align: left;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-item: center;
  flex-direction: row;
`;

export const ButtonDiv = styled.div`
  height: 100%;
  margin-right: 12px;
  @media (max-width: 600px) {
    margin-right: 6px;
  }
  @media (max-width: 300px) {
    margin-right: 6px;
  }
`;

export const ButtonHead = styled.p`
  margin: 0;
  line-height: 1;
  font-size: 15px;

  @media (max-width: 1024px) {
    font-size: 13px;
  }

  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

export const ButtonBase = styled.p`
  margin: 0;
  line-height: 1;
  font-size: 26px;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 600px) {
    font-size: 15px;
  }
`;

export const Button = styled.button`
  font-family: NunitoSans-SemiBold;
  font-weight: 600;
  outline: none;
  border-radius: 8px;
  background: #000000;
  color: white;
  align-self: flex-start;
  padding: 13px 15px;
  border: 0;
  cursor: pointer;
  letter-spacing: 0.5;

  @media (max-width: 600px) {
    margin-top: 24px;
    padding: 6px 8px;
    border-radius: 6px;
    align-self: center;
  }
`;

export const Pane = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  @media (max-width: 1000px) {
    width: 100%;
    flex-direction: column;
    padding: 0 20px;
  }
  @media (max-width: 600px) {
    padding: unset;
    flex-direction: column-reverse;
    ${"" /* padding-left: 35px; */}
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  ${"" /* margin: 0 91px 0 136px; */}
  margin-left: 40px;

  @media (max-width: 1024px) {
    margin: 24px 45px;
  }
  @media (max-width: 600px) {
    margin: 0px;
  }
`;
